export default "__VITE_ASSET__6d374e3f__"